import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import Modal from "../../../components/Modal/Modal";
import { NotificationManager } from "react-notifications";
import AddPropertyHistoryData from "../components/AddPropertyHistoryData";
import AddBovHistoryData from "../components/AddBovHistoryData";

const initialFormData = {
  suggested_sale_price: "",
  bov_date: "",
  suggested_cap_rate:"",
};

const AddBovHistoryModal = ({ showBovModal, onClose, onBovPropertyHistoryAdded }) => {
  const [config] = useAuth();
  const { id } = useParams();
  const [error, setError] = useState();
  const [formData, setFormData] = useState(initialFormData);

  const handleCancel = () => {
    onClose();
    setError();
    setFormData(initialFormData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = {
      suggested_sale_price: formData?.suggested_sale_price,
      bov_date: formData?.bov_date,
      suggested_cap_rate: formData?.suggested_cap_rate,
      property_id: id,
    };
    axios
      .post(`${BASE_URL}/add-bovproperty-history`, dataToSend, config)
      .then(() => {
        onClose();
        handleCancel();
        onBovPropertyHistoryAdded();
      })
      .catch((err) => {
        setError(err?.response?.data?.errors || {});
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const clearError = (field) => {
    setError((prev) => ({ ...prev, [field]: "" }));
  };

  return (
    <Modal title={"Add BOV History"} desc={"Add the BOV history of this property"} show={showBovModal} onClose={handleCancel}>
      <AddBovHistoryData
        formData={formData}
        error={error}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        clearError={clearError}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
      />
    </Modal>
  );
};

export default AddBovHistoryModal;
